// extracted by mini-css-extract-plugin
export default {"GiftTrackerCard__rightIcon":"GiftTrackerCard-styles__GiftTrackerCard__rightIcon__vb9X2"};